module.exports = __webpack_public_path__ + "img/blackbox.14e55fe1.png";